import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { $insertNodes, COMMAND_PRIORITY_EDITOR, createCommand } from 'lexical';
import { useEffect } from 'react';

import { $createImageNode } from '../Nodes/ImageNode';

export const INSERT_IMAGE_COMMAND = createCommand('INSERT_IMAGE_COMMAND');

const ImagePlugin = () => {
  const [editor] = useLexicalComposerContext();

  useEffect(() => {
    const cleanup = editor.registerCommand(
      INSERT_IMAGE_COMMAND,
      (payload) => {
        editor.update(() => {
          const node = $createImageNode(payload);

          if ('fallback' in payload) {
            payload.fallback.replace(node);
          } else {
            $insertNodes([node]);
          }
        });

        return true;
      },
      COMMAND_PRIORITY_EDITOR
    );

    return () => {
      cleanup();
    };
  }, [editor]);

  return null;
};

export default ImagePlugin;
